import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'v2m-using-metadata',
  templateUrl: './using-metadata.component.html',
  styleUrls: ['./using-metadata.component.scss']
})
export class UsingMetadataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
